var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.334 186.67C133.334 168.001 133.347 158.66 136.98 151.53C140.174 145.258 145.257 140.162 151.527 136.966C158.657 133.333 168.01 133.333 186.68 133.333H613.347C632.015 133.333 641.34 133.333 648.47 136.966C654.742 140.162 659.838 145.258 663.034 151.53C666.667 158.66 666.667 168.001 666.667 186.67V211.245C666.667 219.398 666.667 223.477 665.746 227.314C664.929 230.715 663.579 233.964 661.752 236.946C659.691 240.309 656.803 243.197 651.042 248.958L482.284 417.716C476.519 423.48 473.652 426.346 471.591 429.713C469.763 432.693 468.395 435.953 467.578 439.356C466.667 443.153 466.667 447.183 466.667 455.173V613.7C466.667 642.273 466.667 656.57 460.65 665.173C455.394 672.686 447.287 677.7 438.217 679.04C427.83 680.573 415.044 674.19 389.487 661.413L362.82 648.08C352.117 642.73 346.78 640.043 342.87 636.05C339.414 632.52 336.767 628.283 335.157 623.613C333.334 618.33 333.334 612.333 333.334 600.366V455.42C333.334 447.266 333.334 443.193 332.414 439.356C331.597 435.953 330.247 432.693 328.417 429.713C326.37 426.37 323.51 423.51 317.824 417.823L317.707 417.716L148.95 248.958C143.187 243.193 140.32 240.31 138.257 236.946C136.43 233.964 135.06 230.715 134.244 227.314C133.334 223.517 133.334 219.481 133.334 211.493V186.67Z",
    stroke: "white",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filter-White.be7f7cd3a784165b8f782c0c5c03082b.svg";
export { ForwardRef as ReactComponent };